<nz-modal
    [(nzVisible)]="isVisible"
    [nzMaskClosable]="false"
    [nzTitle]="title"
    (nzOnCancel)="close()"
    [nzOkLoading]="submitLoading || loading"
    nzWidth="700px"
    (nzOnOk)="submit()"
>
    <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="loading">
            <form nz-form nz-row [formGroup]="validateForm" class="form-container">
                <div
                    *ngFor="let control of listOfControl; let i = index;"
                    class="row-item"
                    nz-row
                >
                    <div nz-col nzSpan="11" class="select-row">
                        <nz-form-label nzSpan="9" nzRequired>StartTime</nz-form-label>
                        <nz-form-control nzSpan="15" nzErrorTip="Please select startTime">
                            <nz-date-picker
                                [nzDisabled]="control.value?.startDisabled"
                                [nzDisabledDate]="disabledDate"
                                [nzDisabledTime]="disabledTime"
                                [nzShowTime]="{ nzFormat: 'h a', nzUse12Hours: true }"
                                [formControlName]="control.startTime"
                                nzFormat="yyyy-MM-dd h a"
                            ></nz-date-picker>
                        </nz-form-control>
                    </div>

                    <div nz-col nzSpan="11" class="select-row">
                        <nz-form-label nzSpan="9" nzRequired>endTime</nz-form-label>
                        <nz-form-control nzSpan="15" nzErrorTip="Please select endTime">
                            <nz-date-picker
                                [nzDisabled]="control.value?.endDisabled"
                                [nzDisabledDate]="disabledDate"
                                [nzDisabledTime]="disabledTime"
                                [nzShowTime]="{ nzFormat: 'h a', nzUse12Hours: true }"
                                [formControlName]="control.endTime"
                                nzFormat="yyyy-MM-dd h a"
                            ></nz-date-picker>
                        </nz-form-control>
                    </div>

                    <div nz-col nzSpan="1">
                        <i *ngIf="!disabledRemove(i)" nz-icon nzType="minus-circle-o" class="dynamic-delete-button" (click)="removeField(control, $event)"></i>
                    </div>
                </div>
                <button nz-button nzType="primary" class="add-btn" (click)="addField()">
                    <i nz-icon nzType="plus"></i>
                    Add
                </button>
            </form>
        </nz-spin>
    </ng-container>
</nz-modal>
